import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useAuthStore } from '../lib/auth-store';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

function LoginPage() {
  const navigate = useNavigate();
  const { login, register, loading, error } = useAuthStore();
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      if (mode === 'login') {
        await login(email, password);
      } else {
        await register(email, password, displayName);
      }
      navigate({ to: '/' });
    } catch (_e) {
      // 错误已经在 store 里
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg p-4 sm:p-6">
      <div className="w-full max-w-md bg-surface border border-line rounded p-5 sm:p-8">
        <div className="flex items-center gap-3 mb-5 sm:mb-6">
          <span className="w-9 h-9 bg-accent text-white rounded font-bold flex items-center justify-center">
            贸
          </span>
          <div>
            <h1 className="text-lg font-semibold">Trade OS</h1>
            <p className="text-xs text-ink-3">贸易公司业务系统</p>
          </div>
        </div>

        <div className="flex gap-1 p-1 bg-surface-2 rounded mb-5 sm:mb-6">
          <button
            type="button"
            onClick={() => setMode('login')}
            className={`flex-1 py-1.5 text-sm rounded ${
              mode === 'login' ? 'bg-surface shadow-sm font-medium' : 'text-ink-2'
            }`}
          >
            登录
          </button>
          <button
            type="button"
            onClick={() => setMode('register')}
            className={`flex-1 py-1.5 text-sm rounded ${
              mode === 'register' ? 'bg-surface shadow-sm font-medium' : 'text-ink-2'
            }`}
          >
            注册
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {mode === 'register' && (
            <label className="flex flex-col gap-1 text-xs text-ink-2">
              姓名
              <input
                type="text"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                className="px-3 py-2 border border-line rounded text-sm"
                placeholder="您的姓名"
                required
              />
            </label>
          )}
          <label className="flex flex-col gap-1 text-xs text-ink-2">
            邮箱
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="px-3 py-2 border border-line rounded text-sm"
              placeholder="you@example.com"
              required
            />
          </label>
          <label className="flex flex-col gap-1 text-xs text-ink-2">
            密码
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="px-3 py-2 border border-line rounded text-sm"
              minLength={8}
              required
            />
            {mode === 'register' && <span className="text-ink-3">至少 8 位</span>}
          </label>

          {error && (
            <div className="px-3 py-2 bg-bad/10 border border-bad rounded text-xs text-bad">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="py-2.5 bg-accent text-white rounded font-medium hover:bg-accent-2 disabled:opacity-50"
          >
            {loading ? '处理中...' : mode === 'login' ? '登录' : '注册并登录'}
          </button>
        </form>

        <p className="mt-4 text-xs text-ink-3 text-center">首次使用？点上方"注册"创建账号</p>
      </div>
    </div>
  );
}
